import { PRODUCTS } from "../../data/content";
import { SectionHeading } from "../common";
import { ProductCard } from "../ProductCard";
import { TurfTalkCard } from "../TurfTalkCard";
import { Reveal } from "../Reveal";

const commercial = PRODUCTS.filter((p) => p.category === "Commercial Software");
const digital = PRODUCTS.filter((p) => p.category === "Digital Business");

// Locked hierarchy: COMMERCIAL PRODUCTS → TURF TALK DEMONSTRABLE PRODUCT →
// OPERATING DIGITAL BUSINESS → (Active Development section follows separately).
export const BuiltAtTitan = () => (
    <section id="built" className="py-24 md:py-32 border-b border-thg-border" data-testid="built-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                index="02"
                overline="Built at Titan Haven"
                title="Real products. Real operations."
                text="Commercial products first, then demonstrable and operating work. Maturity is labeled, not implied."
            />
            <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="commercial-tier">
                {commercial.map((p, i) => (
                    <Reveal key={p.slug} delay={i * 0.08}>
                        <ProductCard product={p} testId={`product-card-${p.slug}`} compact />
                    </Reveal>
                ))}
            </div>
            {/* Turf Talk — demonstrable working product; SportChant, LTD. product,
                never implied as THG-owned. Shared component, cannot drift. */}
            <Reveal delay={0.1} className="mt-12">
                <TurfTalkCard spotlight />
            </Reveal>
            {/* Operating digital business */}
            <div className="mt-12 grid grid-cols-1" data-testid="digital-tier">
                {digital.map((p) => (
                    <Reveal key={p.slug} delay={0.12}>
                        <ProductCard product={p} testId={`product-card-${p.slug}`} />
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
